import { createSelector } from '@reduxjs/toolkit';

import { currentOpenChatSelector } from '../currentOpenChatSelector';

export const currentChatGaProductsSelector = createSelector(
  [currentOpenChatSelector],
  currentOpenChat => currentOpenChat?.ga?.products,
);
